import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { TlkSlideToggleComponent } from '@itero/ui-toolkit-angular/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { takeUntil } from 'rxjs/operators';
import { ArchAlignmentFacade } from './arch-alignment.facade';
import { ArchAlignmentState } from './arch-alignment.store';

@Component({
	selector: 'rx-intuitive-arch-alignment',
	templateUrl: './rx-intuitive-arch-alignment.component.html',
	styleUrls: ['./rx-intuitive-arch-alignment.component.scss'],
	providers: [ArchAlignmentFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, TranslateModule, TlkCardComponent, TlkSlideToggleComponent]
})
export class RxIntuitiveArchAlignmentComponent extends BaseDestroyableComponent implements OnInit {
	readonly isReadOnly$ = this.facade.isReadOnly$;

	readonly form = this.formBuilder.nonNullable.group<ArchAlignmentState>({
		OnUpperJaw: false,
		OnLowerJaw: false
	});

	get upperJawControl() {
		return this.form.controls.OnUpperJaw;
	}

	get lowerJawControl() {
		return this.form.controls.OnLowerJaw;
	}

	constructor(
		private readonly facade: ArchAlignmentFacade,
		private readonly formBuilder: FormBuilder
	) {
		super();
	}

	ngOnInit(): void {
		this.facade.loadFromRx();
		this.form.patchValue(this.facade.state, { emitEvent: false });

		this.form.controls.OnUpperJaw.valueChanges.pipe(takeUntil(this.componentAlive$)).subscribe(checked => {
			if (!checked && !this.form.controls.OnLowerJaw.value) {
				this.form.controls.OnUpperJaw.setValue(true);
			}
		});

		this.form.controls.OnLowerJaw.valueChanges.pipe(takeUntil(this.componentAlive$)).subscribe(checked => {
			if (!checked && !this.form.controls.OnUpperJaw.value) {
				this.form.controls.OnLowerJaw.setValue(true);
			}
		});

		this.form.valueChanges
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(() => this.facade.updateArchAlignment(this.form.getRawValue()));
	}
}
